import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader1 from '../../components/common/PageHeader1';
import ActiveStatus from "../../components/Form/activeStatus";
import apiClient from "../../utils/api";
import { toast } from 'react-toastify';

function ColorsAdd() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        is_active: "1"
    });

    const handleInputChange = (e) => {
        const { name, type, value, checked } = e.target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('name', formData.name);
        data.append('is_active', formData.is_active);
        
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.post('accounts/colors', data, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Color created successfully');
            navigate(process.env.PUBLIC_URL + '/accounts/colors-list');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error creating color');
        }
    };

    return (
        <div className="container-xxl">
            <form onSubmit={onSubmit}>
                <PageHeader1 pagetitle='Color Add' button={true}/>
                <div className="row g-3">
                    <div className="col-xl-4 col-lg-4">
                        <div className="sticky-lg-top">
                            <div className="card mb-3">
                                <ActiveStatus
                                    onStatusChange={handleInputChange}
                                    checked={formData.is_active}
                                    name="is_active"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-8 col-lg-8">
                        <div className="card mb-3">
                            <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                                <h6 className="mb-0 fw-bold">Basic information</h6>
                            </div>
                            <div className="card-body">
                                <div className="row g-3 align-items-center">
                                    <div className="col-md-12">
                                        <label className="form-label">Color Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default ColorsAdd;